import { PracticeFormQuestion } from "@physiofit-digital/physiofit_types";
import { t } from "i18next";

export const getQuestionTypeChecks = (
  currentQuestion: PracticeFormQuestion,
) => {
  return {
    currentQuestionIsContract: currentQuestion?.answer?.type === "contract",
    currentQuestionIsCostBearer: currentQuestion?.answer?.type === "costBearer",
    questionIsConditionAcceptance:
      currentQuestion?.answer?.type === "conditionAcceptance",
    questionIsPersonalInfo: currentQuestion?.answer?.type === "personalInfo",
    questionIsContract: currentQuestion?.answer?.type === "contract",
    questionIsDocumentUpload:
      currentQuestion?.answer?.type === "documentUpload",
    questionIsRecipeUpload: currentQuestion?.answer?.type === "recipeUpload",
    isQuestionOptional: !currentQuestion?.required,
  };
};

export const calculateTotalQuestionsInForm = (
  formQuestions: PracticeFormQuestion[],
) => {
  return (
    formQuestions?.reduce((total, question) => {
      if (question.answer.type === "costBearer") {
        return total + 3; // we have 3 screens for cost bearer questions
      }
      return total + 1;
    }, 0) ?? 0
  );
};

export const calculateCurrentQuestionIndexInForm = (
  formQuestions: PracticeFormQuestion[],
  currentQuestionIndex: number,
  currentQuestionIsCostBearer: boolean,
  currentCostBearerScreenStep: number,
) => {
  let totalIndex = 0;

  // Count all completed questions before current question
  for (let i = 0; i < currentQuestionIndex; i++) {
    const question = formQuestions?.[i];
    if (question?.answer.type === "costBearer") {
      totalIndex += 3; // Previous cost bearer questions are fully completed (3 screens)
    } else {
      totalIndex += 1;
    }
  }

  // Add current cost bearer screen step if we're on a cost bearer question
  if (currentQuestionIsCostBearer) {
    totalIndex += currentCostBearerScreenStep + 1;
  } else if (currentQuestionIndex < (formQuestions?.length ?? 0)) {
    totalIndex += 1; // Current question if not cost bearer
  }

  return totalIndex;
};

export const getNextButtonText = (
  currentQuestionIsCostBearer: boolean,
  currentCostBearerScreenStep: number,
  currentQuestionIsContract: boolean,
  currentQuestionIndexInForm: number,
  amountTotalQuestions: number,
  questionIsConditionAcceptance: boolean,
) => {
  if (currentQuestionIsCostBearer && currentCostBearerScreenStep < 2) {
    return t("NEXT");
  }

  if (
    (currentQuestionIsCostBearer && currentCostBearerScreenStep === 2) ||
    currentQuestionIsContract
  ) {
    return t("CONTRACT_SIGN_BUTTON");
  }

  if (currentQuestionIndexInForm === amountTotalQuestions) {
    return t("DONE");
  }

  if (questionIsConditionAcceptance) {
    return t("AGREE");
  }

  return t("NEXT");
};

export const getNextButtonDisabled = (
  userCompletedCurrentQuestion: boolean,
  questionIsConditionAcceptance: boolean,
) => {
  return !userCompletedCurrentQuestion && !questionIsConditionAcceptance;
};
